"use client"

import type React from "react"
import "./Disclaimer.css"

const Disclaimer: React.FC = () => {
  return (
    <div className="disclaimer-page">
      <div className="disclaimer-container">
        <div className="disclaimer-header">
          <h1>Acuerdo de participación en MVP de Yuba</h1>
        </div>

        <div className="disclaimer-content">
          <section className="disclaimer-section">
            <h2>I. Antecedentes</h2>
            <p>
              "La Empresa" ha desarrollado un MVP (Minimum Viable Product) enfocado en ofrecer un servicio de rampa que
              permita a los usuarios comprar criptomonedas utilizando moneda fiduciaria (MXN) y, viceversa, vender
              criptomonedas a cambio de MXN. Este MVP busca impulsar la adopción de soluciones innovadoras para
              facilitar el acceso a activos digitales en el mercado.
            </p>
          </section>

          <section className="disclaimer-section">
            <h2>II. Objeto del Acuerdo</h2>
            <p>
              El objeto del presente acuerdo es establecer los términos y condiciones bajo los cuales El Participante
              contribuirá al desarrollo, pruebas y validación del MVP de la plataforma de rampa de acceso y salida de
              activos digitales.
            </p>
          </section>

          <section className="disclaimer-section">
            <h2>III. Alcance de la Participación</h2>
            <p>
              El Participante entiende y acepta que el proyecto se encuentra en una fase de pruebas y que su
              participación se realiza de buena fe, estando al tanto de que el proyecto aún está en proceso de
              cumplimiento de elementos técnicos, regulatorios y de mercado. En consecuencia:
            </p>
            <ol className="disclaimer-list">
              <li>
                El Participante se compromete a utilizar la plataforma de rampa proporcionada en el marco del MVP de
                forma responsable y conforme a las instrucciones y directrices establecidas por "La Empresa".
              </li>
              <li>
                El Participante entiende que su participación es clave para el desarrollo y mejora del producto, y se
                compromete a usar la plataforma únicamente para los fines previstos y dentro de los límites definidos.
              </li>
            </ol>
          </section>

          <section className="disclaimer-section">
            <h2>IV. Confidencialidad y Propiedad Intelectual</h2>
            <p>
              El Participante se compromete a mantener en estricta confidencialidad toda la información relacionada con
              el MVP, y a utilizar dicha información exclusivamente para los fines establecidos en este acuerdo. Además,
              reconoce que toda la información y documentación compartida en el marco de este proyecto es propiedad
              exclusiva de "La Empresa".
            </p>
          </section>

          <section className="disclaimer-section">
            <h2>V. Propiedad Intelectual</h2>
            <p>
              Todos los derechos de propiedad intelectual generados durante y después de la fase de pruebas serán de
              exclusiva propiedad de "La Empresa".
            </p>
          </section>

          <section className="disclaimer-section">
            <h2>VI. Duración y Terminación</h2>
            <p>
              El presente acuerdo entrará en vigor a partir de la fecha de aceptación y tendrá vigencia durante toda la
              fase de pruebas. No obstante, las obligaciones relativas a la "Información Confidencial" permanecerán
              vigentes indefinidamente, incluso después de la finalización del proyecto.
            </p>
          </section>
        </div>

        <section className="disclaimer-footer">
          <div className="footer-content">
            <p>Al utilizar nuestros servicios, usted acepta los términos de este acuerdo.</p>
          </div>
        </section>
      </div>
    </div>
  )
}

export default Disclaimer
